@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'insights.administration.account.title' | translate }}</h2>
	<div class="service-header-buttons">
		<header-sub-menu [favoriteItems]="favoriteItems"></header-sub-menu>
	</div>
</div>

<table class="example-table" mat-table recycleRows [dataSource]="dataSource" matSort>
	<ng-container matColumnDef="name">
		<th mat-header-cell *matHeaderCellDef>
			{{ 'insights.administration.account.colname' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.name }}</td>
	</ng-container>

	<ng-container matColumnDef="groups">
		<th mat-header-cell *matHeaderCellDef>
			{{ 'insights.administration.account.colgroups' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			@for (group of element.groupIds; track group) {
				{{ group }}
				<br />
			}
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<ng-template #tempRef>
	<div class="sidebar-section">
		<h3 class="sidebar-subheader blue">Insights Widget</h3>
	</div>
</ng-template>
